import React, { useState } from "react"
import { EditUserFormTextField } from "./EditUserFormTextField"

interface User {
  id: number
  nickname: string
}

interface NicknameFieldProps {
  user: User
}

export const NicknameField: React.FC<NicknameFieldProps> = ({ user }) => {
  const [value, setValue] = useState(user.nickname || "")

  const fieldData = {
    field: "nickname",
    name: "nickname",
    label: "Nickname",
    placeholder: "Nickname (appears in chat)",
    required: true,
  }

  return (
    <div className="mb-6">
      <EditUserFormTextField
        fieldData={fieldData}
        value={value}
        setValue={setValue}
        userId={user.id}
      />
    </div>
  )
}
